import axios from "axios";
import { Message } from 'element-ui';
import { BASE_URL } from '@/config/api';

// 创建一个axios对象
const request = axios.create({
    baseURL: BASE_URL,
    timeout: 300000 // 超时时间调整为5分钟
});

// request拦截器
request.interceptors.request.use(
    config => {
        config.headers['Content-Type'] = 'application/json;charset=utf-8';

        const user = localStorage.getItem("user");
        // 如果user对象存在并且包含token，则添加到headers中
        if (user) {
            config.headers['token'] = JSON.parse(user).token;
        }
        return config;
    },
    error => {
        // console.error('请求错误:', error);
        Message.error('请求发送失败，请检查网络连接');
        return Promise.reject(error);
    }
);

// response拦截器
request.interceptors.response.use(
    response => {
        let res = response.data;
        // 兼容服务端返回的字符串数据
        if (typeof res === 'string') {
            try {
                res = JSON.parse(res);
            } catch (error) {
                // console.error('Failed to parse JSON:', res);
                Message.error('服务器返回数据格式错误');
                return Promise.reject(new Error('数据格式错误'));
            }
        }
        
        // 直接返回响应数据，让业务代码自己处理错误
        // 不在拦截器中统一显示错误消息，避免重复提示
        return res;
    },
    error => {
        // console.error('响应错误:', error);
        
        // 网络错误
        if (!error.response) {
            if (error.message === 'Network Error') {
                Message({
                    message: '网络连接失败，请检查您的网络设置',
                    type: 'error',
                    duration: 3000,
                    showClose: true
                });
            } else if (error.code === 'ECONNABORTED') {
                Message({
                    message: '请求超时，请稍后重试',
                    type: 'error',
                    duration: 3000,
                    showClose: true
                });
            } else {
                Message({
                    message: '网络异常，请稍后重试',
                    type: 'error',
                    duration: 3000,
                    showClose: true
                });
            }
            return Promise.reject(error);
        }
        
        // HTTP状态码错误处理
        const status = error.response.status;
        let errorMessage = '服务器错误';
        
        switch (status) {
            case 400:
                errorMessage = '请求参数错误';
                break;
            case 401:
                errorMessage = '登录已过期，请重新登录';
                // 清除本地存储的用户信息
                localStorage.removeItem('user');
                // 延迟跳转，让用户看到提示
                setTimeout(() => {
                    window.location.href = '/login';
                }, 1500);
                break;
            case 403:
                errorMessage = '没有权限访问';
                break;
            case 404:
                errorMessage = '请求的资源不存在';
                break;
            case 500:
                errorMessage = '服务器内部错误';
                break;
            case 502:
                errorMessage = '网关错误';
                break;
            case 503:
                errorMessage = '服务暂时不可用';
                break;
            case 504:
                errorMessage = '网关超时';
                break;
            default:
                errorMessage = error.response.data?.msg || `服务器错误 (${status})`;
        }
        
        Message({
            message: errorMessage,
            type: 'error',
            duration: 3000,
            showClose: true
        });
        
        return Promise.reject(error);
    }
);

export default request;